// src/lib/format.js

const MEDIA = process.env.REACT_APP_MEDIA_URL;

// Storage paths come back as "/requip/<uuid>.jpg" or without the slash
export function mediaUrl(path) {
  if (!path) return null;
  return `${MEDIA}/${String(path).replace(/^\/+/, "")}`;
}

const ZAR = new Intl.NumberFormat("en-ZA", {
  style: "currency",
  currency: "ZAR",
  maximumFractionDigits: 0,
});

// Postgres numerics arrive as strings, so this takes either
export function priceLabel(item) {
  const n = Number(item.price);
  if (item.price_on_request || item.price == null || !Number.isFinite(n) || n <= 0) {
    return "Price on request";
  }
  return ZAR.format(n);
}

export function makeModel(item) {
  return [item.make, item.model].filter(Boolean).join(" \u00b7 ");
}

// Specs are stored as JSON and have been entered as either a list of
// { label, value } rows or a flat object, so both are accepted.
export function specRows(specs) {
  if (!specs) return [];
  if (Array.isArray(specs)) {
    return specs
      .map((s) => (Array.isArray(s) ? { label: s[0], value: s[1] } : s))
      .filter((s) => s && s.label && s.value !== "" && s.value != null);
  }
  if (typeof specs === "object") {
    return Object.entries(specs)
      .filter(([, v]) => v !== "" && v != null)
      .map(([label, value]) => ({ label, value: String(value) }));
  }
  return [];
}
